export enum UserTier {
  default = "default",
  default_wl = "default_wl",
  bronze = "bronze",
  bronze_wl = "bronze_wl",
  silver = "silver",
  silver_wl = "silver_wl",
  gold = "gold",
  platinum = "platinum",
  god = "god",
}
